import type { SupervisorFinding } from '@avisoma/shared';
import { Button } from '../catalyst/button';
import { COMPACT_BUTTON_CLASS, isRevertable } from '../lib/findingActions';
import type { FindingRevertHandle } from './supervisorFindingRevert';

/** Revert for an applied or reapplied finding; renders nothing otherwise or without a handle. */
export function FindingRevertButton({ finding, handle }: { finding: SupervisorFinding; handle: FindingRevertHandle | null }) {
  if (!handle || !isRevertable(finding.status)) return null;
  return (
    <Button outline buttonClassName={COMPACT_BUTTON_CLASS} disabled={handle.busy} onClick={() => handle.revert(finding)}>
      Revert
    </Button>
  );
}
